angular.module('unica_auth.auth_controllers')

.controller('LogoutSuccessController', function(
	$rootScope, $scope, $state, $timeout ) {

});